// extracted by mini-css-extract-plugin
export default {"headline":"FaqPage_headline__M2Yx+","content":"FaqPage_content__KhWqk"};